"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusDropdownMenuItem = exports.StatusDropdownControlItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _StatusDisplay = require("../StatusDisplay");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StatusDropdownMenuItem = _ref => {
  let {
    status,
    props
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MenuItem, _extends({}, props, {
    style: {
      display: "flex",
      alignItems: "center"
    },
    text: T.translate("issueStatus.".concat(status)),
    renderLeftComponent: () => /*#__PURE__*/_react.default.createElement(_StatusDisplay.StatusBadge, {
      status: status
    })
  }));
};
exports.StatusDropdownMenuItem = StatusDropdownMenuItem;
const StatusDropdownControlItem = _ref2 => {
  let {
    status,
    onXClick
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      marginRight: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_StatusDisplay.StatusDisplay, {
    status: status
  }), onXClick ? /*#__PURE__*/_react.default.createElement(_alloyReactIcon.XIcon, {
    style: {
      marginLeft: 6,
      color: _alloyReactTheme.default.colors.charcoal900
    },
    size: 14,
    onClick: onXClick
  }) : null);
};
exports.StatusDropdownControlItem = StatusDropdownControlItem;
//# sourceMappingURL=StatusDropdownMenuUtils.js.map